// PostHog client lazy-loaded. No-op se VITE_POSTHOG_KEY ausente.
// Não substitui sentry-lite/web-vitals — complementa com product analytics.
import type { PostHog } from "posthog-js";

let phPromise: Promise<PostHog | null> | null = null;

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com";

export const isAnalyticsEnabled = (): boolean => Boolean(KEY);

async function loadPostHog(): Promise<PostHog | null> {
  if (!KEY) return null;
  if (phPromise) return phPromise;
  phPromise = (async () => {
    try {
      const mod = await import(/* @vite-ignore */ "posthog-js");
      const ph = mod.default;
      ph.init(KEY, {
        api_host: HOST,
        capture_pageview: false, // controlamos manualmente
        persistence: "localStorage",
        autocapture: false,
        disable_session_recording: true,
      });
      return ph;
    } catch {
      return null;
    }
  })();
  return phPromise;
}

export async function trackEvent(name: string, props?: Record<string, unknown>) {
  if (!isAnalyticsEnabled()) return;
  const ph = await loadPostHog();
  ph?.capture(name, props);
}

export async function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!isAnalyticsEnabled()) return;
  const ph = await loadPostHog();
  ph?.identify(userId, traits);
}

export async function resetAnalytics() {
  if (!isAnalyticsEnabled()) return;
  const ph = await loadPostHog();
  ph?.reset();
}
